module.exports = __webpack_public_path__ + "static/img/home_new5.2b1d01e7.jpg";